import { render, staticRenderFns } from "./SchoolsDashBar.vue?vue&type=template&id=774fc044&scoped=true"
import script from "./SchoolsDashBar.vue?vue&type=script&lang=js"
export * from "./SchoolsDashBar.vue?vue&type=script&lang=js"
import style0 from "./SchoolsDashBar.vue?vue&type=style&index=0&id=774fc044&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fc044",
  null
  
)

export default component.exports